/* eslint-disable camelcase */
import React from 'react';
import BiologicalResult from './BiologicalResult/BiologicalResult';
import BiologicalResultsProps from '.';
import Container from './styles';
import SectionHeader from '../SectionHeader/SectionHeader';
import { resolveSignificantPointsOverride } from '../../../../utilities/testResultUtils';

function BiologicalResults({
  totalCholesterol = { thresholdExceeded: false },
  hdl = { thresholdExceeded: false },
  nonHdl = { thresholdExceeded: false },
  ldl = { thresholdExceeded: false },
  totalHdlRatio = { thresholdExceeded: false },
  triglycerides = { thresholdExceeded: false },
  isFemale = undefined,
  hadCardiovascularDisease = undefined,
  pipelineModelRanges = undefined,
  modelId = undefined,
}: BiologicalResultsProps) {
  return (
    <Container>
      <SectionHeader icon="blood-type" title="Lipid Results" />
      <BiologicalResult
        resultType="totalCholesterol"
        value={totalCholesterol.value}
        thresholdExceeded={totalCholesterol.thresholdExceeded}
        significantPointsOverride={resolveSignificantPointsOverride(
          'totalCholesterol',
          pipelineModelRanges,
          modelId,
        )}
      />
      <BiologicalResult
        resultType="hdl"
        value={hdl.value}
        isFemale={isFemale}
        thresholdExceeded={hdl.thresholdExceeded}
        significantPointsOverride={resolveSignificantPointsOverride('hdl', pipelineModelRanges, modelId)}
      />
      <BiologicalResult
        resultType="nonHdl"
        value={nonHdl.value}
        thresholdExceeded={nonHdl.thresholdExceeded}
        hadCardiovascularDisease={hadCardiovascularDisease}
        significantPointsOverride={resolveSignificantPointsOverride(
          'nonHdl',
          pipelineModelRanges,
          modelId,
        )}
      />
      <BiologicalResult
        resultType="ldl"
        ldlNotCalculated={
          hdl.thresholdExceeded ||
          totalCholesterol.thresholdExceeded ||
          triglycerides.thresholdExceeded
        }
        value={ldl.value}
        thresholdExceeded={ldl.thresholdExceeded}
        hadCardiovascularDisease={hadCardiovascularDisease}
        significantPointsOverride={resolveSignificantPointsOverride('ldl', pipelineModelRanges, modelId)}
      />
      <BiologicalResult
        resultType="totalHdlRatio"
        value={totalHdlRatio.value}
        thresholdExceeded={totalHdlRatio.thresholdExceeded}
        significantPointsOverride={resolveSignificantPointsOverride(
          'totalHdlRatio',
          pipelineModelRanges,
          modelId,
        )}
      />
      <BiologicalResult
        resultType="triglycerides"
        value={triglycerides.value}
        thresholdExceeded={triglycerides.thresholdExceeded}
        significantPointsOverride={resolveSignificantPointsOverride(
          'triglycerides',
          pipelineModelRanges,
          modelId,
        )}
      />
    </Container>
  );
}

export default BiologicalResults;
